module.exports = __webpack_public_path__ + "static/media/vf_wvest_core.91d3622d.svg";